import { queryOptions } from "@tanstack/react-query";
import {
  listAthleteProductPayments,
  listMyProductSubscriptions,
  type Api,
} from "api-client";

type MyProductPayments = Api.ListMyProductSubscriptions.Output.Self;
type AthleteProductPayments = Api.ListAthleteProductPayments.Output.Self;

export type MyProductSubscription =
  MyProductPayments["subscriptions"]["currentPage"][number];
export type MyProductPayment =
  MyProductPayments["payments"]["currentPage"][number];
export type AthleteProductSubscription =
  AthleteProductPayments["subscriptions"]["currentPage"][number];
export type CoachProductSubscriptions =
  Api.ListProductSubscriptions.Output.Self;
export type CoachProductSubscription =
  Api.ListProductSubscriptions.Output.CurrentPage;
export type ProductSubscriptionStatus = AthleteProductSubscription["status"];
export type ProductPageInfo =
  AthleteProductPayments["subscriptions"]["pageInfo"];

export interface ProductPaymentsPageQuery {
  subscriptionsPageIndex: number;
  subscriptionsPageSize: number;
  paymentsPageIndex: number;
  paymentsPageSize: number;
}

export const productSubscriptionKeys = {
  all: ["product-subscriptions"] as const,
  mine: (query: ProductPaymentsPageQuery) => {
    return [...productSubscriptionKeys.all, "mine", query] as const;
  },
  athletePayments: (athleteId: string, query: ProductPaymentsPageQuery) => {
    return [
      ...productSubscriptionKeys.all,
      "athlete-payments",
      athleteId,
      query,
    ] as const;
  },
};

export function myProductSubscriptionsQueryOptions(
  query: ProductPaymentsPageQuery,
) {
  return queryOptions({
    queryKey: productSubscriptionKeys.mine(query),
    queryFn: () => {
      return listMyProductSubscriptions({ query }).then((res) => {
        return res.data.data;
      });
    },
  });
}

export function athleteProductPaymentsQueryOptions(
  athleteId: string,
  query: ProductPaymentsPageQuery,
) {
  return queryOptions({
    queryKey: productSubscriptionKeys.athletePayments(athleteId, query),
    queryFn: () => {
      return listAthleteProductPayments({ path: { athleteId }, query }).then(
        (res) => {
          return res.data.data;
        },
      );
    },
  });
}
